module.exports = __webpack_public_path__ + "img/left_menu_active.c82b3fc.webp";